import type { PilotIconName } from './PilotIcon';

export interface PilotDestination { label: string; path: string; icon: PilotIconName; anyOf?: string[]; description: string }

export const pilotDestinations: PilotDestination[] = [
  { label: 'Home', path: '/dashboard', icon: 'home', description: 'Ask Mirra and view your fleet' },
  { label: 'Tenants', path: '/tenants', icon: 'tenants', anyOf: ['tenants.read', 'tenants.manage'], description: 'Browse tenant workspaces' },
  { label: 'Showrooms', path: '/showrooms', icon: 'showrooms', anyOf: ['showrooms.manage'], description: 'Scenarios and showroom tenants' },
  { label: 'Releases', path: '/releases', icon: 'releases', anyOf: ['releases.read', 'releases.manage', 'releases.promote'], description: 'Release registry and assignments' },
  { label: 'MQTT', path: '/mqtt', icon: 'mqtt', anyOf: ['mqtt.manage', 'mqtt.read'], description: 'Brokers, topics and messages' },
  { label: 'AI', path: '/ai', icon: 'ai', anyOf: ['ai.read'], description: 'Mirra policies and usage' },
  { label: 'Insights', path: '/analytics', icon: 'insights', anyOf: ['analytics.read'], description: 'Platform analytics and allocated cost' },
  { label: 'Access', path: '/access-control', icon: 'access', anyOf: ['users.read', 'users.manage', 'roles.read', 'roles.manage', 'analytics.read'], description: 'Provider people and roles' },
];

export function permittedDestinations(hasPermission: (key: string) => boolean): PilotDestination[] {
  return pilotDestinations.filter(item => !item.anyOf || item.anyOf.some(hasPermission));
}

export function getEnvironmentLabel(hostname: string): string {
  if (['localhost', '127.0.0.1', '[::1]', '::1'].includes(hostname)) return 'Local';
  if (hostname === '24k.infinity.surbana.tech') return 'Staging';
  if (hostname === '24k.infinity.com') return 'Production';
  return 'Environment unverified';
}
